import React, { useEffect, useRef, RefObject } from 'react';

import { clsx } from 'clsx';

import useIntersection from 'src/hooks/useIntersection';

import { PLANETS } from './constants';

import { motion } from 'framer-motion';

import styles from './Planets.scss';

const Planets = () => {
  const containerRef: RefObject<HTMLDivElement> = useRef(null);
  const inViewport = useIntersection({ element: containerRef });

  const variants = {
    initial: { opacity: 0, y: 200 },
    animate: (custom: number) => ({
      opacity: 1,
      y: 0,
      transition: { delay: 1.5, duration: custom / 2 },
    }),
  };

  const parallax = (e): void => {
    const planets: NodeListOf<HTMLImageElement> = document.querySelectorAll('#planet');

    planets.forEach((planet) => {
      const speed: number = parseInt(planet.getAttribute('data-speed')!, 10);

      if (typeof window !== 'undefined') {
        const x = (window.innerWidth - e.pageX * speed) / 100;
        const y = (window.innerHeight - e.pageY * speed) / 100;

        planet.style.transform = `translateX(${x}px) translateY(${y}px)`;
        planet.style.transition = 'all 0.15s';
      }
    });
  };

  useEffect(() => {
    document.addEventListener('mousemove', parallax);

    if (!inViewport) {
      document.removeEventListener('mousemove', parallax);
    }

    return () => {
      document.removeEventListener('mousemove', parallax);
    };
  }, [inViewport]);

  return (
    <div ref={containerRef} className={styles.planets}>
      {PLANETS.map((planet) => (
        <motion.img
          id="planet"
          data-speed={planet.speed}
          key={planet.id}
          className={clsx(styles.planet, styles[`planet${planet.id}`])}
          src={planet.src}
          alt="planet"
          variants={variants}
          custom={planet.id}
          initial="initial"
          animate="animate"
        />
      ))}
    </div>
  );
};

export default Planets;
